import Paper from "@mui/material/Paper";

const ProductDescription = (props) => {
    const { 
        product_description_long,
        long_term_product,
        long_desc,
     } = props;
    return (
            <div id="description">
                {long_term_product ? (
                    <>
                        <h2>Long Term Furniture Hire - What Is It &amp; How Can It Benefit You?</h2>
                        <p>At its most simple long term furniture hire is when you choose to rent our products
                            for a longer length of time, and the top reason many of our customers opt for this
                            is as equally straightforward - it saves them money!</p>
                        <h2>Why we think renting furniture long-term is the way to go...</h2>
                        <p>Saving money is a great benefit to hiring chairs, tables, desks and any other item
                            from our range, but there are lots of other advantages too, which we’ve mentioned
                            here so you can decide if renting this way is for you.</p>
                        <ul>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> No need to use your
                                capital expenditure for office furniture</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> We deliver and collect
                                your entire order at affordable rates</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> When you select our
                                installation service we also set up all items</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> Get your furniture
                                delivered quickly via our next day deliveries</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> It doesn’t matter
                                where you live in mainland UK - we deliver nationwide</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> All this makes it easy
                                to change, update and replace goods quickly</li>
                            <li style={{marginLeft:'15px'}}><i className="icon-star"></i> We’re always adding to
                                our stocks so we can offer modern products</li>
                        </ul>
                    </>
                ) : null}

                {/* <ParseHtml html={long_desc}/> */}
                <Paper
                    className='default-grey reset-list'
                    variant='renderHtml'

                    id="description-container" 
                    dangerouslySetInnerHTML={{
                        __html: long_desc
                    }}
                />

            

                
            </div>
    )
}

export default ProductDescription